 <template>
    <h2>BienvenidoXX</h2>
    <p>[Placeholder para usuarios]</p>
    <p>[Mostrar estado de la documentación propia]</p>
    <p>[Mostrar consumos?]</p>
</template>

<script>
export default {
    name: "InicioUsuarios",
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 960px) {
    ::v-deep(.p-datatable) {
        &.p-datatable-customers {
            .p-datatable-thead > tr > th,
            .p-datatable-tfoot > tr > td {
                display: none !important;
            }

            .p-datatable-tbody > tr {
                border-bottom: 1px solid #dee2e6;
                > td {
                    text-align: left;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 0 none !important;
                    width: 100% !important;
                    float: left;
                    clear: left;
                    border: 0 none;

                    .p-column-title {
                        padding: 0.4rem;
                        min-width: 30%;
                        display: inline-block;
                        margin: -0.4rem 1rem -0.4rem -0.4rem;
                        font-weight: bold;
                    }

                    .p-progressbar {
                        margin-top: 0.5rem;
                    }
                }
            }
        }
    }
}
</style>
